var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledImageBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5995_12362)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42349 0H15.5765C16.0979 0 16.5176 0.409025 16.5176 0.917086V2.49234H21.7814C23.0105 2.49234 24 3.456 24 4.6536V16.8382C24 16.8574 23.9997 16.8766 23.9992 16.8957C23.9997 16.9304 24 16.9652 24 17C24 20.866 20.866 24 17 24C13.829 24 11.1504 21.8915 10.2899 19H2.21857C0.989524 19 0 18.0358 0 16.8382V4.6536C0 3.456 0.989524 2.49234 2.21857 2.49234H7.48233V0.917086C7.48233 0.409025 7.90209 0 8.42349 0ZM11 17L11 16.9987C11.0001 16.5277 11.0545 16.0695 11.1572 15.6298C11.777 12.9764 14.1577 11 17 11C17.0252 11 17.0505 11.0002 17.0756 11.0005C17.5592 11.0064 18.029 11.0696 18.4786 11.1836C21.0773 11.8422 23 14.1965 23 17C23 17.6256 22.9042 18.2289 22.7266 18.7959C21.9633 21.2323 19.6881 23 17 23C14.3876 23 12.1651 21.3304 11.3414 19C11.1203 18.3744 11 17.7013 11 17ZM18.4656 10.1537C18.3247 8.69278 17.6658 7.3179 16.592 6.27165C15.3742 5.08493 13.7223 4.41823 12 4.41823C10.2777 4.41823 8.62585 5.08493 7.40797 6.27165C6.19008 7.45837 5.50588 9.0679 5.50588 10.7462C5.50588 12.4244 6.19008 14.034 7.40797 15.2207C8.1421 15.936 9.0339 16.4624 10.0038 16.7677C10.0194 16.2893 10.083 15.8231 10.1899 15.3736C9.52687 15.1274 8.91766 14.7462 8.40622 14.2479C7.4531 13.3191 6.91763 12.0595 6.91763 10.7461C6.91763 9.43263 7.4531 8.173 8.40622 7.24426C9.35935 6.31553 10.6521 5.79376 12 5.79376C13.3479 5.79376 14.6406 6.31553 15.5938 7.24426C16.3645 7.99531 16.8622 8.96275 17.0244 10C17.5185 10.0017 18.0006 10.0546 18.4656 10.1537Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18.2L19.8 21L21 19.8L18.2 17L21 14.2L19.8 13L17 15.8L14.2 13L13 14.2L15.8 17L13 19.8L14.2 21L17 18.2Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5995_12362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledImageBlack);
export default __webpack_public_path__ + "static/media/DisabledImageBlack.1593f7bfaeae572135235628dc0ca33b.svg";
export { ForwardRef as ReactComponent };